import { render, staticRenderFns } from "./HackathonsManage.vue?vue&type=template&id=4ab33e08&"
import script from "./HackathonsManage.vue?vue&type=script&lang=js&"
export * from "./HackathonsManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports